import React, { MouseEvent, KeyboardEvent } from "react";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import styles from "./check-box-text-wrapper.module.scss";
import checkBoxIcon from "@src/assets/svg/checkbox-icon.svg";
import checkBoxCheckedIcon from "@src/assets/svg/checked-checkbox-icon.svg";

interface CheckBoxTextWrapperPropTypes {
  text: string;
  checkboxState: boolean;
  handleCheckBoxClick: (
    e: MouseEvent | KeyboardEvent,
    checkboxState: boolean,
  ) => void;
}

const cssClassName = "check-box-text-wrapper";

export const CheckBoxTextWrapper = ({
  text,
  checkboxState,
  handleCheckBoxClick,
}: CheckBoxTextWrapperPropTypes) => {
  const returnCheckboxIconByState = (childInfo: boolean) => {
    return childInfo ? checkBoxCheckedIcon : checkBoxIcon;
  };

  const handleClick = (e: MouseEvent | KeyboardEvent) => {
    e.preventDefault();
    handleCheckBoxClick(e, !checkboxState);
  };

  return (
    <div className={styles[cssClassName]}>
      <IconButton
        icon={returnCheckboxIconByState(checkboxState)}
        fun={handleClick}
      />
      <span className={styles[`${cssClassName}__label`]}>{text}</span>
    </div>
  );
};
